export type PeriodType = 'today' | 'period';

export enum EReportApiType {
    chargebacks = 'chargebacks',
    failed_transactions = 'failed_transactions',
    balance_seller = 'balance-seller',
    comission = 'comission', // single-m matches N8N webhook contract (legacy typo, intentional)
    tax_commissions = 'tax_commissions',
}

export type ReportConfig = {
    id: string;
    apiType: EReportApiType;
    titleKey: string;
    descriptionKey: string;
    drawerTitleKey: string;
    drawerDescriptionKey: string;
};

